import Home from "~/themes/sparkasse/components/Home.vue";
import Contacts from "~/components/forms/Contacts.vue";
import PersonalData from "~/components/forms/PersonalData.vue";
import PersonalData2 from "~/components/forms/PersonalData2.vue";
import EmployeeLoan from "~/components/forms/EmployeeLoan.vue";
import IncomeData from "~/components/forms/IncomeData.vue";
import FamilyIncome from "~/components/forms/FamilyIncome.vue";
import EmployerData from "~/components/forms/EmployerData.vue";
import LoanProtection from "~/components/forms/LoanProtection.vue";
import LoanProtectionConsent from "~/components/forms/LoanProtectionConsent.vue";
import LoanProtectionWarning from "~/components/forms/LoanProtectionWarning.vue";
import DeliveryData from "~/components/forms/DeliveryData.vue";
import IdentityDocData from "~/components/forms/IdentityDocData.vue";
import PaymentData from "~/components/forms/PaymentData.vue";
import PersonalCredit from "~/components/forms/RatePersonalCredit.vue";
import PersonalCreditUpgrade from "~/components/forms/RatePersonalCredit.vue";
import Partner from "~/components/forms/Partner.vue";

import Typ from "../components/ui/Typ.vue";
import CustomCredit from "~/components/static/CustomCredit.vue";
import Login from "../components/forms/Login.vue";
import TypKO from "~/components/typ/TypKO.vue";
import EmailPrivacy from "~/components/forms/EmailPrivacyBanks.vue";

export default {
  Home,
  Contacts,
  PersonalData,
  PersonalData2,
  EmployeeLoan,
  IncomeData,
  FamilyIncome,
  EmployerData,
  LoanProtection,
  LoanProtectionConsent,
  LoanProtectionWarning,
  DeliveryData,
  IdentityDocData,
  PaymentData,
  PersonalCredit,
  Partner,
  Typ,
  CustomCredit,
  Login,
  PersonalCreditUpgrade,
  TypKO,
  EmailPrivacy
};
